import { ReactNode } from 'react';

import ResidentsChangeLogProviderContext from 'features/residents/resident-change-logs/providers/contexts/residents-change-log-provider-context';
import useResidentsChangeLogState from 'features/residents/resident-change-logs/providers/states/residents-change-log-state';

type Props = {
  children: ReactNode;
};

const ResidentsChangeLogProvider = ({ children }: Props): React.JSX.Element => (
  <ResidentsChangeLogProviderContext value={useResidentsChangeLogState()}>{children}</ResidentsChangeLogProviderContext>
);

export default ResidentsChangeLogProvider;
